import { getEnv } from "@/env";

export const API_V1_URL = getEnv("VUE_APP_API_URL");
export const API_V2_URL = getEnv("VUE_APP_API_V2_URL");
export const API_EMAIL_URL = getEnv("VUE_APP_API_URL_EMAIL");

/**
 * SMS Fraud
 */
export const SMS_BASE_URL = `${API_V2_URL}/v1/sms`;
export const SMS_FRAUD_WHITELIST_URL = `${SMS_BASE_URL}/fraud-whitelist`;
export const SMS_DIAGNOSTICS_URL = `${SMS_BASE_URL}/diagnostics`;
export const SMS_SPAM_REPORTS_URL = `${API_V1_URL}/v1/sms_spam_report`;

/**
 * Email service
 */
export const EMAIL_BASE_URL = `${API_EMAIL_URL}/v1/emails/sendgrid`;
export const EMAIL_SUPPRESSION_URL = `${EMAIL_BASE_URL}/suppression`;
export const EMAIL_SUPPRESSION_TYPE_URL = (type) =>
  `${EMAIL_SUPPRESSION_URL}/${type}`;
export const EMAIL_SUPPRESSION_TYPE_EMAIL_URL = (type, email) =>
  `${EMAIL_SUPPRESSION_TYPE_URL(type)}/${email}`;

export const PRODUCT_UPDATES_ACCOUNT = "PRODUCT_UPDATES";

export const SMP_DIAGNOSTICS_URL =
  "https://tap-smp-diagnostics.8x8.com/smpdiagnostics/report/home";
